import React from 'react';
import { FiSave, FiShield, FiBell, FiCpu } from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';

const SettingsView = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-8">
      <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-2">
        <span className="w-2 h-8 bg-slate-500 rounded-full shadow-[0_0_10px_rgba(100,116,139,0.5)]"></span>
        System Configuration
      </h1>

      <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden">
        <div className="flex border-b border-slate-800">
          <button className="px-6 py-4 text-sm font-medium text-blue-400 border-b-2 border-blue-500 bg-slate-800/50 flex items-center gap-2">
            <SafeIcon icon={FiCpu} /> AI Integrations
          </button>
          <button className="px-6 py-4 text-sm font-medium text-slate-400 hover:text-slate-200 hover:bg-slate-800/30 flex items-center gap-2">
            <SafeIcon icon={FiShield} /> Security
          </button>
          <button className="px-6 py-4 text-sm font-medium text-slate-400 hover:text-slate-200 hover:bg-slate-800/30 flex items-center gap-2">
            <SafeIcon icon={FiBell} /> Notifications
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <h3 className="text-slate-200 font-medium mb-2">Auto-Screening Sensitivity</h3>
            <p className="text-sm text-slate-500 mb-4">Adjust how aggressively the AI filters inbound applications based on required skills.</p>
            <input type="range" className="w-full h-2 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-blue-500" defaultValue="70" />
            <div className="flex justify-between text-xs text-slate-500 mt-2">
              <span>Lenient</span>
              <span>Strict</span>
            </div>
          </div>

          <div className="pt-6 border-t border-slate-800">
            <h3 className="text-slate-200 font-medium mb-4">Connected Modules</h3>
            <div className="space-y-3">
              <label className="flex items-center justify-between p-3 bg-slate-950 rounded-lg border border-slate-800 cursor-pointer">
                <div>
                  <p className="text-sm text-slate-200 font-medium">Auto-schedule Interviews</p>
                  <p className="text-xs text-slate-500">Allow AI to propose times based on calendar availability.</p>
                </div>
                <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                  <input type="checkbox" name="toggle" id="toggle1" className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 border-slate-600 appearance-none cursor-pointer checked:right-0 checked:border-blue-500 transition-all" defaultChecked />
                  <label htmlFor="toggle1" className="toggle-label block overflow-hidden h-5 rounded-full bg-slate-800 cursor-pointer"></label>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div className="p-4 bg-slate-950 border-t border-slate-800 flex justify-end">
          <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors shadow-[0_0_15px_rgba(59,130,246,0.3)]">
            <SafeIcon icon={FiSave} /> Save Configuration
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;